import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { AppRouter } from '@/router/routes'
import { AppErrorBoundary } from '@/shared/components/AppErrorBoundary'
import { buildAppMode } from '@/shared/buildMode'
import '@/index.css'

if (import.meta.env.DEV) {
  console.info('[SPA] mode:', buildAppMode, '· env:', import.meta.env.VITE_APP_MODE)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AppErrorBoundary>
  </StrictMode>,
)
